module.exports = __webpack_public_path__ + "fonts/DM_Serif_Display-400-latin3.48631b1.woff2";